<template>
  <v-row justify="center">
    <v-card class="transparent my-3 mx-auto" rounded outlined width="900">
      <v-card-text style="height: calc(100vh - 175px); overflow-y: auto;">
        <div class="d-flex align-center mb-6">
          <img class="mt-n2" :src="require('@/assets/appLogo-color--Onlight.svg')" width="100"/>
        </div>

        <span class="text-h5 font-weight-medium">Crea tu organización</span>
        <span class="ml-3 body-1 text--primary">Aquí es donde tu equipo va a colaborar.</span>

        <v-list class="mt-6 transparent" dense>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="ml-1 body-1 text--secondary font-weight-regular overflow-visible">Nombre de la organización</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="11" class="py-0 pl-0">
                  <v-text-field v-model.trim="$v.newAccount.name.$model" :error="$v.newAccount.name.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle>
                <v-row class="px-3">
                  <v-col cols="6" class="py-0 pl-0">
                    <span class="ml-1 body-1 text--secondary font-weight-regular">¿Desde que país opera la organización?</span>
                    <v-select v-model="$v.newAccount.country.$model" :error="$v.newAccount.country.$error" :items="baseCountries" single-line item-text="name" item-value="id" hide-details dense height="30" outlined background-color="white" />
                  </v-col>
                  <v-col cols="5" class="py-0 pl-0">
                    <span class="ml-1 body-1 text--secondary font-weight-regular">ID Fiscal <span class="body-2 text--primary">(VAT, RUT, RUC, RFC o DNI)</span></span>
                    <v-text-field v-model.trim="$v.newAccount.tax_id.$model" :error="$v.newAccount.tax_id.$error" v-dni="newAccount.country" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="ml-1 body-1 text--secondary font-weight-regular overflow-visible">¿Qué describe mejor la industria de tu organización?</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6" class="py-0 pl-0">
                  <v-select v-model="$v.newAccount.economic_sector.$model" :error="$v.newAccount.economic_sector.$error" :items="economicSectors" single-line item-text="label" item-value="id" hide-details dense height="30" outlined background-color="white" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="ml-1 body-1 text--secondary font-weight-regular overflow-visible">¿Cuántas personan trabajan en tu organización?</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="3" class="py-0 pl-0">
                  <v-select v-model="$v.newAccount.employee_quantity.$model" :error="$v.newAccount.employee_quantity.$error" :items="employeeQuantities" single-line item-text="label" item-value="id" hide-details dense height="30" outlined background-color="white" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions class="pa-10">
        <v-spacer/>
        <span class="mr-6 red--text" v-if="showError">{{ errorMessage }}</span>
        <v-btn class="pr-3 pl-6" @click="submit" color="primary" large :loading="creatingAccount" :disabled="creatingAccount" :ripple="false">
          Continuar<v-icon dark right size="22">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { required, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'
import { rutValidator } from 'vue-dni'
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [GenericViewMixin],
  data: () => ({
    creatingAccount: false,
    showError: false,
    errorMessage: '',
    newAccount: {
      country: '',
      economic_sector: '',
      name: '',
      tax_id: '',
      employee_quantity: ''
    },
    economicSectors: [
      { id: 'b2b_saas', label: 'B2B / SaaS' },
      { id: 'digital_media', label: 'Medios digitales' },
      { id: 'nonprofit', label: 'Organizaciones sin fines de lucro' },
      { id: 'consulting', label: 'Servicios profesionales y/o consultoría' },
      { id: 'banks', label: 'Banco y servicios financieros' },
      { id: 'insurance', label: 'Seguros' },
      { id: 'health', label: 'Salud' },
      { id: 'edtech', label: 'Ed-tech' },
      { id: 'telecom', label: 'Telecomunicaciones' },
      { id: 'retail', label: 'Retail / E-commerce' },
      { id: 'logistics', label: 'Logística' },
      { id: 'trips', label: 'Viajes' },
      { id: 'other', label: 'Otro' }
    ],
    employeeQuantities: [
      { id: '1_19', label: '1 - 19' },
      { id: '20_49', label: '20 - 49' },
      { id: '50_99', label: '50 - 99' },
      { id: '100_250', label: '100 - 250' },
      { id: '251_500', label: '251 - 500' },
      { id: '501_1500', label: '501 - 1500' },
      { id: '1500+', label: 'Más de 1500' }
    ]
  }),
  computed: {
    ...mapState({
      responses: state => state.onboarding.responses,
      account: state => state.auth.account,
      trace: state => state.auth.trace
    })
  },
  watch: {
    'newAccount.country' () {
      this.newAccount.tax_id = ''
    }
  },
  created () {
    this.$store.dispatch('auth/RETRIEVE_TRACE')

    this.$store.dispatch('onboarding/LOAD_USER_PROFILE').then(() => {
      if (!this.responses.role || !this.responses.channels.length) {
        this.$router.push({ name: 'UserOnboarding' })
        return
      }

      if (this.account && this.account.id) {
        this.$router.push({ name: 'OrganizationOnboarding' })
        return
      }

      if (this.trace && this.trace.loc) {
        this.newAccount.country = this.trace.loc
      }
    })
  },
  methods: {
    submit () {
      if (this.creatingAccount) return

      this.$v.newAccount.$touch()
      if (this.$v.newAccount.$invalid) {
        this.showError = true
        this.errorMessage = 'Corrige los campos marcados.'
        return
      }

      this.creatingAccount = true
      this.$store.dispatch('accounts/CREATE', {
        resource: 'accounts',
        payload: {
          country: this.newAccount.country,
          name: this.newAccount.name,
          tax_id: this.newAccount.tax_id
        }
      })
        .then((response) => {
          const account = response.data
          this.identifyOrg(account)

          this.$store.commit('auth/SET_ACCOUNT', {
            account: account,
            redirect: false
          })
          this.$store.commit('onboarding/SET_ORG_CREATED', true)

          this.showError = false
          this.errorMessage = ''
          this.trackEvent('Onboarding Step Completed', { step: 'create_org' })

          this.$router.push({ name: 'OrganizationOnboarding' })
        })
        .catch((error) => {
          this.showError = true
          if (error.response && error.response.data && error.response.data.tax_id) {
            this.errorMessage = error.response.data.tax_id[0]
          } else {
            this.errorMessage = 'Error al crear la cuenta.'
          }
        })
        .finally(() => {
          this.creatingAccount = false
        })
    },
    identifyOrg (account) {
      if (process.env.NODE_ENV !== 'production') {
        return
      }

      this.$analytics.group(account.id, {
        createdAt: account.created,
        economic_sector: this.newAccount.economic_sector,
        employee_quantity: this.newAccount.employee_quantity,
        name: this.newAccount.name,
        tax_id: account.tax_id
      })
    }
  },
  validations: {
    newAccount: {
      country: {
        required
      },
      economic_sector: {
        required
      },
      name: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(64)
      },
      tax_id: {
        required: requiredIf(function () {
          const country = this.baseCountries.find(c => c.id === this.newAccount.country)

          if (!country) {
            return false
          }

          return country.hasRegulation
        }),
        taxId: function (val) {
          if (this.newAccount.country === 'CL') {
            return rutValidator(val)
          }

          return true
        },
        maxLength: maxLength(32)
      },
      employee_quantity: {
        required
      }
    }
  }
}
</script>
